import React, { Component } from "react";
import { connect } from "react-redux";
import { TextField } from "office-ui-fabric-react/lib/TextField";
import { TooltipHost } from "office-ui-fabric-react/lib/Tooltip";
import { METRIC, IMPERIAL } from "../../../lib/types";
import "./index.css";
import ProjectSelectors from "../../../reducers/project-reducer";
import ToggleVolumeIconComponent from "../ToggleVolumeIcon";

class PipeTopCalculationsComponent extends Component{
    render() {
        const {
            lbl,
            unit,
            lang,
            area,
            width,
            volume,
            length,
            content,
            pipeBedWidth,
            pipeBedLength,
            availableWidth,
            requiredVolume,
            availableLength,
            numberOfPipeRows,
            pipeNominalDiameter,
            lengthOutsideFittings,
            lengthBetweenFittings,
            lengthFittingsOnCenter,
            isMultiBedProject,
            selectedBed,
            totalVolume,
            totalLength,
            totalArea,
            totalWidth,
            totalPipeRows,
            totalLengthOutsideFittings,
            totalLengthBetweenFittings,
            totalLengthFittingsOnCenter,
            totalBeds,
            hideVolumesComponent,
        } = this.props;

        const convertUnits = ( value, unitType ) => {
            let unitValue = 0;
            if (isNaN(parseFloat(value))) value = 0; // Added as a control to avoid the NaN warning on screen.
            switch (unit) {
                case METRIC:
                    switch (unitType) {
                        case "cf":
                            unitValue = parseFloat(Math.round(( value / 35.315 ) * 100) / 100).toFixed(2);
                            break;
                        case "ft":
                            unitValue = parseFloat(Math.round(( value * 0.3048 ) * 100) / 100).toFixed(2);
                            break;
                        case "sf":
                            unitValue = parseFloat(Math.round(( value / 10.764 ) * 100) / 100).toFixed(2);
                            break;
                        default:
                            unitValue = Math.round(value * 100) / 100;
                            break;
                    }
                    break;
                case IMPERIAL:
                    unitValue = Math.round(value * 100) / 100;
                    break;
                default:
                    break;
            }
            return unitValue;
        };

        const renderCalculated = ( value, label, fieldStyle, tutorialClass, unitType, overrideClassName ) => {


            try {
                return (
                    <div
                        style={{ fontWeight: "bold" }}
                        className={overrideClassName
                            ? overrideClassName
                            : `${tutorialClass} top-calculations-field`}
                    >
                        {
                            fieldStyle !== null
                                ? (
                                    <TooltipHost content={fieldStyle.text} directionalHint="bottom">
                                        <TextField
                                            key={value}
                                            label={label}
                                            readOnly={true}
                                            style={fieldStyle.color}
                                            value={unitType === "string" ? value : convertUnits(value, unitType)}
                                        />
                                    </TooltipHost>
                                )
                                : (
                                    <TextField
                                        key={value}
                                        label={label}
                                        readOnly={true}
                                        value={unitType === "string" ? value : convertUnits(value, unitType)}
                                    />
                                )
                        }
                    </div>
                );
            } catch (e) {
                return null;
            }

        };

        let volumeFieldStyle = {};
        let overrideFieldStyle = {};

        if (requiredVolume > 0 && volume < requiredVolume) {
            volumeFieldStyle = { color: css.errorColor, text: content[lang].insuficientVolume };
        } else if (
            requiredVolume === 0 ||
            ( volume >= requiredVolume &&
                volume <= requiredVolume + pipeNominalDiameter.getPipeRowVolume(numberOfPipeRows * pipeNominalDiameter.pitch.ft) )
        ) {
            volumeFieldStyle = { color: css.okColor, text: content[lang]["optimalVolume"] };
        } else {
            volumeFieldStyle = { color: css.warningColor, text: content[lang]["exceedingVolume"] };
        }

        // change color for override total volume
        function truncateNumber(num, fixed) { // I need this to magically align numbers
            let re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
            return Number(num.toString().match(re)[0]);
        }
        if (truncateNumber(this.props.multibedOverallSiteVolume, 2) > 0 && truncateNumber( totalVolume.toFixed(2), 2) < truncateNumber(this.props.multibedOverallSiteVolume, 2)) {
            overrideFieldStyle = { color: css.errorColor, text: content[lang].insuficientVolume };
        } else if (
          truncateNumber(this.props.multibedOverallSiteVolume, 2) === 0 ||
          ( truncateNumber( totalVolume.toFixed(2), 2) >= truncateNumber(this.props.multibedOverallSiteVolume, 2) &&
            truncateNumber( totalVolume.toFixed(2), 2) <= truncateNumber(this.props.multibedOverallSiteVolume, 2) + pipeNominalDiameter.getPipeRowVolume(numberOfPipeRows * pipeNominalDiameter.pitch.ft) )
        ) {
            overrideFieldStyle = { color: css.okColor, text: content[lang]["optimalVolume"] };
        } else {
            overrideFieldStyle = { color: css.warningColor, text: content[lang]["exceedingVolume"] };
        }




        let lengthFieldStyle = {};
        if (length.ft > availableLength) {
            lengthFieldStyle = { color: css.errorColor, text: content[lang].exceedingAvailableLength };
        } else {
            lengthFieldStyle = { color: css.okColor, text: content[lang].belowAvailableLength };
        }

        /* determine the color of width field */
        let widthFieldStyle = {};
        if (width.ft > availableWidth) {
            widthFieldStyle = { color: css.errorColor, text: content[lang].exceedingAvailableWidth };
        } else {
            widthFieldStyle = { color: css.okColor, text: content[lang].belowAvailableWidth };
        }

        const isOnOverviewTab = true;
        const overrideClassName = "ms-Grid-col ms-sm12 ms-md12 ms-lg3 ms-xl3 ms-xxl3 multiBedFixedCalc";
        const overrideClassNameTotals = "ms-Grid-col ms-sm4 ms-md4 ms-lg2 ms-xl2 ms-xxl2 pipeMultiBedFixedCalc";
        const showSingleBedTtl = !isMultiBedProject || ( isMultiBedProject && !isOnOverviewTab );

        return (
            <React.Fragment>
                {!hideVolumesComponent && (
                    <div className="fixTopCalculations fix_top_calculations_bar_single_bed">
                        <div className="ms-Grid-row top-calculations-bar" style={css.padding}>
                            {
                                !showSingleBedTtl
                                    ? ( <React.Fragment>
                                        <div className="overrideClassNameLabel">
                                            <div className="totalBedsContainerPipe">
                                                <label className="totalBedsLabelPipe">{content[lang].totalAllBeds}</label>
                                            </div>
                                        </div>
                                    </React.Fragment> )
                                    : null
                            }
                            {renderCalculated(
                                showSingleBedTtl ? volume : totalVolume,
                                `${content[lang].volume} (${lbl[unit].cf[lang]})`,
                                showSingleBedTtl ? volumeFieldStyle : overrideFieldStyle,
                                "tutorialPipeVolume",
                                "cf",
                                !showSingleBedTtl ? overrideClassNameTotals : null,
                            )}
                            {pipeBedLength !== undefined && showSingleBedTtl
                                ? renderCalculated(
                                    showSingleBedTtl ? pipeBedLength.ft : totalLength,
                                    `${content[lang].systemLength} (${lbl[unit].ft[lang]})`,
                                    lengthFieldStyle,
                                    "tutorialPipeLength",
                                    "ft",
                                    !showSingleBedTtl ? overrideClassNameTotals : null)
                                : null
                            }
                            {lengthOutsideFittings !== undefined && showSingleBedTtl
                                ? renderCalculated(
                                    showSingleBedTtl ? lengthOutsideFittings.ft : totalLengthOutsideFittings,
                                    `${content[lang].lengthOutsideFittings} (${lbl[unit].ft[lang]})`,
                                    null,
                                    "tutorialLengthOutsideFittings",
                                    "ft",
                                    !showSingleBedTtl ? overrideClassNameTotals : null)
                                : null
                            }
                            {lengthBetweenFittings !== undefined && showSingleBedTtl
                                ? renderCalculated(
                                    showSingleBedTtl ? lengthBetweenFittings.ft : totalLengthBetweenFittings,
                                    `${content[lang].lengthBetweenFittings} (${lbl[unit].ft[lang]})`,
                                    null,
                                    "tutorialLengthBetweenFittings",
                                    "ft",
                                    !showSingleBedTtl ? overrideClassNameTotals : null)
                                : null
                            }
                            {lengthFittingsOnCenter !== undefined && showSingleBedTtl
                                ? renderCalculated(
                                    showSingleBedTtl ? lengthFittingsOnCenter.ft : totalLengthFittingsOnCenter,
                                    `${content[lang].lengthFittingsOnCenter} (${lbl[unit].ft[lang]})`,
                                    null,
                                    "tutorialLengthFittingsOnCenter",
                                    "ft",
                                    !showSingleBedTtl ? overrideClassNameTotals : null)
                                : null
                            }
                            {pipeBedWidth !== undefined && showSingleBedTtl
                                ? renderCalculated(
                                    showSingleBedTtl ? pipeBedWidth.ft : totalWidth,
                                    `${content[lang].systemWidth} (${lbl[unit].ft[lang]})`,
                                    showSingleBedTtl ? widthFieldStyle : null,
                                    "tutorialPipeWidth",
                                    "ft",
                                    !showSingleBedTtl ? overrideClassNameTotals : null)
                                : null
                            }
                            {renderCalculated(
                                !isMultiBedProject ? area : totalArea,
                                `${content[lang].area} (${lbl[unit].sf[lang]})`,
                                null,
                                "tutorialPipeArea",
                                "sf",
                                !showSingleBedTtl ? overrideClassNameTotals : null,
                            )}
                            {showSingleBedTtl ?
                                renderCalculated(
                                    !isMultiBedProject ? numberOfPipeRows : totalPipeRows,
                                    content[lang].numberOfRows,
                                    null,
                                    "tutorialPipeRows",
                                    null,
                                    !showSingleBedTtl ? overrideClassNameTotals : null)
                                : null
                            }
                            {!showSingleBedTtl
                                ? renderCalculated(
                                    totalBeds,
                                    content[lang].numberOfBeds,
                                    null,
                                    "tutorialPipeRows",
                                    null,
                                    overrideClassNameTotals)
                                : null
                            }
                        </div>
                        {showSingleBedTtl && (
                            <div className="ms-Grid-row" style={{ position: "absolute", width: "100%", margin: "0 auto" }}>
                                <ToggleVolumeIconComponent/>
                            </div>
                        )}
                    </div>
                )}
                {hideVolumesComponent && (
                    <div className="ms-Grid-row" style={{ position: "absolute", width: "100%", margin: "0 auto" }}>
                        <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg8 ms-xl9 ms-xxl9 ms-xxxl10">
                            <ToggleVolumeIconComponent/>
                        </div>
                    </div>
                )}
                {
                    !hideVolumesComponent && isMultiBedProject && isOnOverviewTab && (
                        <div className="fixTopCalculations fix_bottom_calculations_bar">
                            <div className="ms-Grid-row multi-bed-selected-calcs">
                                {
                                    <React.Fragment>
                                        <div className={overrideClassName}>
                                            <div className="selectedBedLabelContainer">
                                                <label className="selectedBedLabel">{selectedBed.name}</label>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                }
                                {renderCalculated(
                                    ///selectedBed.volume, // volume,
                                    volume, // volume,
                                    `${content[lang].volume} (${lbl[unit].cf[lang]})`,
                                    volumeFieldStyle,
                                    "tutorialPipeVolume",
                                    "cf",
                                    overrideClassName,
                                )}
                                {
                                    selectedBed.length !== undefined
                                        ? renderCalculated(selectedBed.length, //pipeBedLength.ft,
                                            `${content[lang].systemLength} (${lbl[unit].ft[lang]})`,
                                            lengthFieldStyle,
                                            "tutorialPipeLength",
                                            "ft",
                                            overrideClassName)
                                        : null
                                }
                                {
                                    selectedBed.lengthBetweenFittings !== undefined
                                        ? renderCalculated(selectedBed.lengthBetweenFittings, // lengthBetweenFittings.ft,
                                            `${content[lang].lengthBetweenFittings} (${lbl[unit].ft[lang]})`,
                                            null,
                                            "tutorialLengthBetweenFittings",
                                            "ft",
                                            overrideClassName)
                                        : null
                                }
                                {
                                    selectedBed.lengthFittingsOnCenter !== undefined
                                        ? renderCalculated(selectedBed.lengthFittingsOnCenter, // lengthFittingsOnCenter.ft,
                                            `${content[lang].lengthFittingsOnCenter} (${lbl[unit].ft[lang]})`,
                                            null,
                                            "tutorialLengthFittingsOnCenter",
                                            "ft",
                                            overrideClassName)
                                        : null
                                }
                                {
                                    selectedBed.width !== undefined
                                        ? renderCalculated(selectedBed.width,// pipeBedWidth.ft,
                                            `${content[lang].systemWidth} (${lbl[unit].ft[lang]})`,
                                            widthFieldStyle,
                                            "tutorialPipeWidth",
                                            "ft",
                                            overrideClassName)
                                        : null
                                }
                                {renderCalculated(
                                    selectedBed.area, // area,
                                    `${content[lang].area} (${lbl[unit].sf[lang]})`,
                                    null,
                                    "tutorialPipeArea",
                                    "sf",
                                    overrideClassName,
                                )}
                                {renderCalculated(
                                    selectedBed.numberOfPipeRows, //numberOfPipeRows,
                                    content[lang].numberOfRows,
                                    null,
                                    "tutorialPipeRows",
                                    null,
                                    overrideClassName,
                                )}
                                {renderCalculated(
                                    selectedBed.pipeSizeNominalDiameter, // pipeSize,
                                    content[lang].pipeSize,
                                    null,
                                    "tutorialPipeSize",
                                    "in",
                                    overrideClassName,
                                )}
                                {renderCalculated(
                                    selectedBed.pipeTypeName, // pipeType, //For fittings
                                    content[lang].pipeType,
                                    null,
                                    "tutorialPipeType",
                                    "string",
                                    overrideClassName,
                                )}

                            </div>
                            <div className="ms-Grid-row"
                                 style={{ position: "absolute", width: "100%", margin: "0 auto", marginTop: "-4px" }}>
                                <ToggleVolumeIconComponent/>
                            </div>
                        </div>
                    )
                }
            </React.Fragment>
        );
    }
}

const css = {
    padding: {
        paddingTop: "5px",
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
    },
    errorColor: {
        boxShadow: "0px 0px 2px 2px red",
    },
    okColor: {
        boxShadow: "0px 0px 2px 2px green",
    },
    warningColor: {
        boxShadow: "0px 0px 2px 2px orange",
    },
};

const mapStateToProps = state => {
    const {
        pipeNominalDiameter,
        pipeAvailableWidth: availableWidth,
        pipeRequiredVolume: requiredVolume,
        pipeAvailableLength: availableLength,
    } = state.pipeGlobals;

    const {
        area,
        volume,
        dimensions,
        pipeElements,
        numberOfPipeRows,
        numberOfPipeSticks,
        numberOfManifoldTees,
        manifoldTeeDistribution,
    } = state.pipeBed;

    const {
        width,
        length,
    } = dimensions;

    const {
        lang,
        content,
    } = state.localization;


    // console.log("state.multiBed.selectedBed", state.multiBed.selectedBed.numberOfPipeRows);


    return {
        pipeElements,
        availableWidth,
        requiredVolume,
        availableLength,
        numberOfPipeRows,
        numberOfPipeSticks,
        pipeNominalDiameter,
        numberOfManifoldTees,
        manifoldTeeDistribution,
        width,
        length,
        area,
        volume,
        lang,
        content,
        isMultiBedProject: ProjectSelectors.isMultiBedProject(),
        isOnOverviewTab: state.multiBed.isOnOverviewTab,
        selectedBed: state.multiBed.selectedBed,
        totalVolume: state.multiBed.totalVolume,
        totalLength: state.multiBed.totalLength,
        totalWidth: state.multiBed.totalWidth,
        totalArea: state.multiBed.totalArea,
        totalPipeRows: state.multiBed.totalPipeRows,
        totalLengthOutsideFittings: state.multiBed.totalLengthOutsideFittings,
        totalLengthBetweenFittings: state.multiBed.totalLengthBetweenFittings,
        totalLengthFittingsOnCenter: state.multiBed.totalLengthFittingsOnCenter,
        multibedIsDirty: state.multiBed.isDirty,
        totalBeds: state.multiBed.beds.length,
        pipeSize: state.pipeGlobals.pipeNominalDiameter._pipeND._inches,
        pipeType: state.pipeGlobals.pipeType._name,
        hideVolumesComponent: state.multiBed.hideVolumesComponent,
        multibedOverallSiteVolume: state.multiBed.overallSiteVolume
    };
};

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PipeTopCalculationsComponent);



// WEBPACK FOOTER //
// ./src/components/LayoutSections/TopCalculations/pipeTopCalculations.component.js